import { Navigate, useLocation } from 'react-router-dom';
import Loading from '../components/Loading';
import { useUser } from '../providers/UserProvider';

export const ClientRoute = ({ children }: { children: React.ReactNode }) => {
    const { isLoading, isAuthenticated } = useUser();
    const location = useLocation();

    if (isLoading) {
        return <Loading />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return <>{children}</>;
};

export const AdminRoute = ({ children }: { children: React.ReactNode }) => {
    const { isLoading, isAuthenticated, user } = useUser();
    const location = useLocation();

    if (isLoading) {
        return <Loading />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    if (!user?.database.data.isAdmin) {
        return <Navigate to="/home" replace />;
    }

    return <>{children}</>;
};
